import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import shapes from '../../common/shapes';
import { FORM_STATUS } from '../../common/globals';

class FormListItem extends PureComponent {
  handleEditForm = () => {
    const {
      form,
      onEditForm
    } = this.props;

    onEditForm(form.id);
  };

  handleViewForm = () => {
    const {
      form,
      onViewForm
    } = this.props;

    onViewForm(form.link);
  };
  
  render() {
    const { form } = this.props;
    const {
      status,
      title
    } = form;

    const statusIcon = status === FORM_STATUS.LIVE
      ? <span title="Form is published!" className="glyphicon glyphicon-record live" />
      : <span className="glyphicon glyphicon-record draft" />;

    return (
      <div className="row form-list-item-container">
        <div className="col-xs-8 col-lg-10">
          {statusIcon}
          <span className="title">{title}</span>
          <button
            type="button"
            className="btn btn-link"
            onClick={this.handleEditForm}
          >
            (edit)
          </button>
        </div>
        {(status === FORM_STATUS.LIVE) && (
          <div className="col-xs-4 col-lg-2 text-right">
            <button
              type="button"
              className="btn btn-link"
              onClick={this.handleViewForm}
            >
              <i className="glyphicon glyphicon-share" />
              Open form
            </button>
          </div>
        )}
      </div>
    );
  }
}

FormListItem.propTypes = {
  form: PropTypes.shape(shapes.form).isRequired,
  onViewForm: PropTypes.func.isRequired,
  onEditForm: PropTypes.func.isRequired
};

export default FormListItem;
